import { create } from 'zustand';

const useOperatorInstallationsStore = create((set, get) => ({
  // Modal states
  showCreateEditModal: false,
  showViewModal: false,
  selectedInstallation: null,
  editInstallation: null,

  // Actions
  setShowCreateEditModal: (show) => set({ showCreateEditModal: show }),
  setShowViewModal: (show) => set({ showViewModal: show }),
  setSelectedInstallation: (installation) => set({ selectedInstallation: installation }),
  setEditInstallation: (installation) => set({ editInstallation: installation }),

  // Combined actions
  openCreateModal: () =>
    set({
      showCreateEditModal: true,
      editInstallation: null,
    }),

  openEditModal: (installation) =>
    set({
      showCreateEditModal: true,
      editInstallation: installation,
    }),

  openViewModal: (installation) =>
    set({
      showViewModal: true,
      selectedInstallation: installation,
    }),

  closeCreateEditModal: () =>
    set({
      showCreateEditModal: false,
      editInstallation: null,
    }),

  closeViewModal: () =>
    set({
      showViewModal: false,
      selectedInstallation: null,
    }),

  // ── Installations-list header triggers ──────────────────────────────────
  // The page header owns the create/upload CTAs (toolbar contract, op-mod
  // phase 2) while the supplier-installation modal + upload wizard live in
  // the table — these flags let the header fire them from outside.
  stockCreateOpen: false,
  openStockCreate: () => set({ stockCreateOpen: true }),
  closeStockCreate: () => set({ stockCreateOpen: false }),
  stockUploadRequested: false,
  requestStockUpload: () => set({ stockUploadRequested: true }),
  clearStockUploadRequest: () => set({ stockUploadRequested: false }),
}));

export default useOperatorInstallationsStore;
